import { CSSProperties } from 'react'

import { Icon } from '../Icon'
import { OutText } from './OutText'

import './styles.scss'

interface IRotativeIconProps {
  /**
   * Aceita px como número ou qualquer comprimento CSS, para que o ícone possa
   * acompanhar um corpo de texto fluido. As proporções internas derivam dele.
   */
  size?: number | string
}

export function RotativeIcon({ size = 230 }: IRotativeIconProps) {
  const cssSize = typeof size === 'number' ? `${size}px` : size

  return (
    <div
      className="rotative-icon"
      style={{ '--rotative-icon-size': cssSize } as CSSProperties}
    >
      <div className="text-animation">
        <OutText />
      </div>

      <div className="base-container">
        <div className="icon-wrapper">
          <Icon color="var(--secondary)" />
        </div>
      </div>
    </div>
  )
}
